module.exports = __webpack_public_path__ + "static/media/WeChat_Guide_Chin_Apple.b34550c8.pdf";